import type { CellProps } from 'react-table';
import { Dashboard } from '@/components/icons/Dashboard';
import ClickContainer from './ResultClickContainer';
import type { DashboardsTableItem } from './interfaces';
import styles from './style/Cell.Name.module.css';

export default function Name({ row: { original: data } }: CellProps<DashboardsTableItem>) {
  return (
    <ClickContainer className={styles.overflowWrapper} item={data}>
      <div className={styles.root}>
        <Dashboard
          className={styles.icon} />
        <div className={styles.details}>
          <div className={styles.name}>{data.name}</div>
        </div>
      </div>
    </ClickContainer>
  );
}

export { Name };